import { category_tabs, obligations, summary_cards } from './obligations_register_data';
import { obligation_drawer_catalog } from './obligations_register_drawers';

function build_obligation_drawer(row) {
  if (!row) {
    return null;
  }

  const obligation_drawer = Reflect.get(obligation_drawer_catalog, row.ref) || null;
  return obligation_drawer;
}

export default {
  name: 'ComplyonObligationsRegister',
  data: () => ({
    summary_cards,
    category_tabs,
    obligations,
    active_filter: 'all',
    search_query: '',
    active_obligation_ref: null
  }),
  computed: {
    filtered_obligations() {
      const query = this.search_query.trim().toLowerCase();

      return this.obligations.filter((row) => {
        const matches_filter = this.active_filter === 'all' || row.category === this.active_filter;
        const matches_query = !query || [row.ref, row.obligation, row.source, row.owner, row.frequency, row.status]
          .some((value) => String(value).toLowerCase().includes(query));

        return matches_filter && matches_query;
      });
    },
    active_obligation() {
      return build_obligation_drawer(this.obligations.find((row) => row.ref === this.active_obligation_ref) || null);
    }
  },
  methods: {
    set_filter(filter_id) {
      this.close_obligation_drawer();
      this.active_filter = filter_id;
    },
    open_obligation_drawer(row) {
      if (!row) {
        return;
      }

      this.active_obligation_ref = row.ref || null;
      this.$nextTick(() => {
        const drawer_body = this.$refs.obligationDrawerBody;
        if (drawer_body) {
          drawer_body.scrollTop = 0;
        }
      });
    },
    close_obligation_drawer() {
      this.active_obligation_ref = null;
    }
  },
  mounted() {
    if (this.active_obligation_ref && typeof document !== 'undefined') {
      document.body.classList.add('obligations-drawer-open');
    }
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('obligations-drawer-open');
    }
  },
  watch: {
    active_obligation_ref(is_open) {
      if (typeof document === 'undefined') {
        return;
      }

      document.body.classList.toggle('obligations-drawer-open', Boolean(is_open));
    }
  }
};
